import { render, staticRenderFns } from "./AddManagedAcademyMember.vue?vue&type=template&id=445908ef&scoped=true"
import script from "./AddManagedAcademyMember.vue?vue&type=script&lang=js"
export * from "./AddManagedAcademyMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445908ef",
  null
  
)

export default component.exports